import { Avatar } from "@mui/material";

type ProviderIconProps = {
  provider?: string;
};

const getProviderColorClass = (provider: string): string => {
  switch (provider.toLowerCase()) {
    case "openai":
      return "bg-[var(--success)]";
    case "anthropic":
      return "bg-sky-500";
    case "cohere":
      return "bg-[var(--secondary)]";
    case "mistral":
      return "bg-[var(--primary)]";
    case "groq":
      return "bg-[var(--warning)]";
    case "private":
      return "bg-[var(--secondary)]";
    default:
      return "bg-[var(--muted)]";
  }
};

const providerMap: Record<string, string> = {
  openai: "/providers/openai.ico",
  anthropic: "/providers/anthropic.webp",
  cohere: "/providers/cohere.svg",
  mistral: "/providers/mistral.webp",
  groq: "/providers/groq.png",
};

const ProviderIcon = ({ provider = "" }: ProviderIconProps) => {
  const normalizedProvider = provider.toLowerCase();
  const iconPath = providerMap[normalizedProvider];

  if (!iconPath) {
    return (
      <Avatar className={`h-6 w-6 ${getProviderColorClass(provider)}`}>
        {provider.charAt(0).toUpperCase()}
      </Avatar>
    );
  }

  return (
    <Avatar
      src={iconPath}
      alt={provider}
      className="h-6 w-6 border border-[var(--border)]"
      imgProps={{
        className: "object-contain",
      }}
    />
  );
};

export default ProviderIcon;
